<script setup>
import {inject, nextTick, onMounted, ref} from "vue";
import PostContainer from "./components/PostContainer.vue";
import {ClientJS} from "clientjs";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const categoryId = inject('categoryId');
const userId = inject('userId');
const postId = inject('postId');

const NUMBER = 3;

// 描画投稿データ
const posts = ref([]);

// ページ
const phase = ref(1);

// 次のページがあるかどうか
const isNext = ref(true);

// ページを読み込む
const more = async () => {
  const mainColumn = document.querySelector('.gbMainContainer');
  const beforeMainColumnHeight = mainColumn ? mainColumn.offsetHeight : 0;

  // 読み込みを試みる
  try {
    // 取得を試みる
    const response = await fetch(siteUrl+'place/get-relation-posts-by-category/'+categoryId+'?number='+NUMBER+'&page='+phase.value+'&ignore='+postId+'&fingerprint='+(new ClientJS()).getFingerprint());

    // JSON パースを試みる
    const data = await response.json();

    // 追加
    posts.value = posts.value.concat(data.posts);

    // DOM反映後にメインカラムの増加分を通知する
    await nextTick();

    if (mainColumn && beforeMainColumnHeight > 0) {
      const increasedHeight = mainColumn.offsetHeight - beforeMainColumnHeight;

      if (increasedHeight > 0) {
        window.dispatchEvent(new CustomEvent('gb:main-column-grown', {
          detail: {
            heightDiff: increasedHeight
          }
        }));
      }
    }

    // 次のページがあるかどうか
    isNext.value = data.next;

    // ページを進める
    phase.value++;

  }

    // 特に何もしない(例外で処理を中断するために存在)
  catch (e) {
    console.error(e);
  }
};

// データを読み込む（描画後に遅延させて ClientJS による LCP ブロックを防ぐ）
onMounted(() => {
  setTimeout(() => {
    more();
  }, 0);
});
</script>

<template>
  <div>
    <PostContainer
      v-for="post in posts"
      :key="post.id"
      container-type="list"
      :login-user-id="userId"
      :post="post"
    />
    <p
      v-if="isNext"
      class="lyMaxW400px lyBlockCnt"
    >
      <button
        class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontBlack pBackColorGray4 pBorder1pxSolidBlack pBorderRadius2px"
        @click="more"
      >
        もっと見る
        <span class="lyBlock lyW16px lyMl8"><img
          :src="siteUrl+'images/btnIconRightArrowBlack.svg'"
          width="16"
          height="16"
          loading="lazy"
          alt=""
        ></span>
      </button>
    </p>
  </div>
</template>
